import CryptoJS from "crypto-js";
import { detect } from "detect-browser";
import publicIp from "public-ip";

const browser = detect();
export const platform = window.navigator.platform;
export const userAgent = window.navigator.userAgent;
export const browserName = browser
  ? `${browser.name} ${browser.version}`
  : "Unknown Browser";

let cachedIP = "";
publicIp
  .v4()
  .then((ip) => (cachedIP = ip))
  .catch(() => {});

export const getIP = () => cachedIP;

export const getBrowserTimeZone = () => {
  let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
  let formatTime = off?.split("GMT")[1].split(" (")[0];
  if (formatTime && formatTime.search(/\+/g) != null) {
    formatTime = formatTime.replace(/\+/g, "%2B");
  } else if (formatTime && formatTime.search(/\-/g) != null) {
    formatTime = formatTime.replace(/\-/g, "%2D");
  }
  return `GMT${formatTime}`;
};

export const formatTime = getBrowserTimeZone().replace("GMT", "");

export const getCommonMetadata = () => {
  return {
    browserTimeZone: getBrowserTimeZone(),
    useragent: userAgent,
    Browser: browserName,
    Os: platform,
    isFromMobile: true,
    clinicId: "20",
    appname: "C2MD Patient",
  };
};

export const getHashCode = () => {
  return CryptoJS.SHA256(
    process.env.REACT_APP_PREFIX +
      process.env.REACT_APP_TOKEN +
      process.env.REACT_APP_SECRETKEY
  ).toString();
};

export const getPasswordHash = (password) => {
  return CryptoJS.SHA512("C2MD|" + password).toString();
};
